import api from './client'

// Cobro por WhatsApp de pedidos web sin pagar (Martin, 26 sep 2026): tres
// mensajes manuales (un juego para pedidos comunes y otro para membresías) que salen de la línea del sistema como plantillas
// aprobadas por Meta, y una respuesta automática con el link a Ventas cuando
// el cliente contesta. La configuración es solo del super administrador.
const base = '/whatsapp-cobros'

export const whatsappCobrosApi = {
  // Configuración (SA)
  config: () => api.get(base),
  // tipo: 'pedido' (pedido común) | 'membresia' (trae una membresía del Wine Club)
  // con_imagen: el banner de Ligier como cabecera de imagen (Martin, 27 sep 2026)
  guardarPlantilla: (tipo, etapa, { texto, boton_texto, con_imagen }) => api.put(`${base}/plantillas/${tipo}/${etapa}`, { texto, boton_texto, con_imagen: !!con_imagen }),
  enviarAMeta: (tipo, etapa) => api.post(`${base}/plantillas/${tipo}/${etapa}/enviar-a-meta`),
  sincronizar: () => api.post(`${base}/sincronizar`),
  guardarRespuestaAutomatica: (texto) => api.put(`${base}/respuesta-automatica`, { texto }),

  // Envío de una instancia (1, 2 o 3) a un pedido web (SA)
  enviar: (pedidoId, etapa) => api.post(`/carritos-abandonados/${pedidoId}/whatsapp/${etapa}`),
  // Corregir el teléfono del pedido antes de mandar (el número al que sale se ve en el botón)
  telefono: (pedidoId, telefono) => api.put(`/carritos-abandonados/${pedidoId}/whatsapp/telefono`, { telefono }),
}
